// extracted by mini-css-extract-plugin
export default {"sib-toggle-button-wrapper":"GU3VquZq1ASgkULhSYK9","sib-toggle-button--slider":"jkhwQOooUNHDoEfnwZW_","sib-btn":"KYVtcJlzkqASDEr5XSpk","sib-btn--selected":"dXrelg9wWz9xCEqw0dRl"};